export default "__VITE_ASSET__rh9NQZ$J__"